export default __webpack_public_path__ + "static/media/LogoBlack.1ec16d4b.svg";